import { defineComponent as _defineComponent } from 'vue'
import { onMounted, computed } from "vue";
import { useMessage } from "naive-ui";
import { useStore } from "@/store";
import { useSetUserServiceGroups } from "./useSetUserServiceGroups";
import { useSetUserInformation } from "./useSetUserInformation";
import Drawer from "@/views/Docs/components/DrawerView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppInner',
  setup(__props, { expose: __expose }) {
  __expose();

const loggedIn = computed(() => useStore().getters["user/isLoggedIn"]);
const message = useMessage();

onMounted(async () => {
  if (loggedIn.value) {
    const { setUserServiceGroups } = useSetUserServiceGroups();
    const { setUserInformation } = useSetUserInformation();

    const promisesToSettle: Array<Promise<void>> = [
      setUserServiceGroups(),
      setUserInformation(),
    ];

    const results = await Promise.allSettled(promisesToSettle);
    const rejected = results.filter((result) => result.status === "rejected");

    // TODO: Show better message related to which promise failed.
    if (rejected.length) {
      message.error(
        "Failed to set user related information. Please reach out to support@telemetryhub.com for assistance."
      );
    }
  }
});

const __returned__ = { loggedIn, message, onMounted, computed, get useMessage() { return useMessage }, get useStore() { return useStore }, get useSetUserServiceGroups() { return useSetUserServiceGroups }, get useSetUserInformation() { return useSetUserInformation }, Drawer }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})